import React, { useState } from "react";

export function ModeSelect({
	name,
	onNameChange,
	initialRoomCode,
	onStartSolo,
	onCreateRoom,
	onJoinRoom,
	onViewLeaderboard,
	onOpenSettings,
	error,
}: {
	name: string;
	onNameChange: (name: string) => void;
	initialRoomCode: string;
	onStartSolo: () => void;
	onCreateRoom: () => void;
	onJoinRoom: (code: string) => void;
	onViewLeaderboard: () => void;
	onOpenSettings: () => void;
	error: string | null;
}) {
	const [showMultiplayer, setShowMultiplayer] = useState(initialRoomCode.length > 0);
	const [roomCodeInput, setRoomCodeInput] = useState(initialRoomCode);

	return (
		<div className="App menu-screen">
			<h1>RK Beach Rampage</h1>
			<div className="pixel-panel pixel-frame menu-panel">
				<h2>Select Mode</h2>
				<div className="field-pixel">
					<label htmlFor="player-name">Racer Name</label>
					<input
						id="player-name"
						type="text"
						placeholder="Your name"
						value={name}
						onChange={(event) => onNameChange(event.target.value)}
					/>
				</div>

				{!showMultiplayer ? (
					<div className="menu-actions">
						<button className="btn-pixel btn-pixel--primary" onClick={onStartSolo} disabled={!name}>
							Solo
						</button>
						<button className="btn-pixel btn-pixel--secondary" onClick={() => setShowMultiplayer(true)} disabled={!name}>
							Multiplayer
						</button>
					</div>
				) : (
					<div>
						<hr className="menu-divider" />
						<div className="menu-actions">
							<button className="btn-pixel btn-pixel--primary" onClick={onCreateRoom} disabled={!name}>
								Create Room
							</button>
						</div>
						<div className="field-pixel">
							<label htmlFor="room-code">Room Code</label>
							<input
								id="room-code"
								type="text"
								placeholder="Room code"
								value={roomCodeInput}
								onChange={(event) => setRoomCodeInput(event.target.value.toUpperCase())}
							/>
						</div>
						<div className="menu-actions">
							<button
								className="btn-pixel btn-pixel--secondary"
								onClick={() => onJoinRoom(roomCodeInput)}
								disabled={!name || !roomCodeInput}
							>
								Join Room
							</button>
							<button className="btn-pixel btn-pixel--ghost" onClick={() => setShowMultiplayer(false)}>
								Back
							</button>
						</div>
					</div>
				)}
				{error && <p className="menu-error">{error}</p>}
			</div>

			<div className="menu-footer-actions">
				<button className="btn-pixel" onClick={onViewLeaderboard}>
					Leaderboard
				</button>
				<button className="btn-pixel" onClick={onOpenSettings}>
					Settings
				</button>
			</div>
		</div>
	);
}
